/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetOnboardingCompanyParams,
  GetOnboardingCountryParams,
  GetOnboardingGradeParams,
  GetOnboardingGroupParams,
  GetOnboardingInfoFromParams,
  GetOnboardingInternationalParams,
  GetOnboardingJobParams,
  GetOnboardingNameParams,
  GetOnboardingReOnboardingParams,
  GetOnboardingRegionParams,
  GetOnboardingStateParams,
  GetOnboardingSubjectParams,
  GetOnboardingToolParams,
  ListOnboardingCompaniesParams,
  OnboardingCompaniesResult,
  OnboardingCompanyStep,
  OnboardingCompanyStepInput,
  OnboardingCompletionResult,
  OnboardingCountryStep,
  OnboardingCountryStepInput,
  OnboardingGradeStep,
  OnboardingGradeStepInput,
  OnboardingGroupStep,
  OnboardingGroupStepInput,
  OnboardingInfoFromStep,
  OnboardingInfoFromStepInput,
  OnboardingInternationalStep,
  OnboardingInternationalStepInput,
  OnboardingJobStep,
  OnboardingJobStepInput,
  OnboardingNameStep,
  OnboardingNameStepInput,
  OnboardingNextPathResult,
  OnboardingReOnboardingState,
  OnboardingRedirectResult,
  OnboardingRegionStep,
  OnboardingRegionStepInput,
  OnboardingState,
  OnboardingSubjectStep,
  OnboardingSubjectStepInput,
  OnboardingToolStep,
  OnboardingToolStepInput,
  SchemaValidationErrorResponse,
  SkipOnboardingCompanyParams,
  SkipOnboardingGroupParams,
  SkipOnboardingJobParams,
  UpdateOnboardingCompanyParams,
  UpdateOnboardingCountryParams,
  UpdateOnboardingGradeParams,
  UpdateOnboardingGroupParams,
  UpdateOnboardingInfoFromParams,
  UpdateOnboardingInternationalParams,
  UpdateOnboardingJobParams,
  UpdateOnboardingNameParams,
  UpdateOnboardingRegionParams,
  UpdateOnboardingSubjectParams,
  UpdateOnboardingToolParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List onboarding companies
 */
export const listOnboardingCompanies = (
    params?: MaybeRefOrGetter<ListOnboardingCompaniesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingCompaniesResult>(
      {url: `/onboarding/companies`, method: 'GET',
        params, signal
    },
      );
    }




export const getListOnboardingCompaniesQueryKey = (params?: MaybeRefOrGetter<ListOnboardingCompaniesParams>,) => {
    return [
    'onboarding','companies', ...(params ? [params] : [])
    ] as const;
    }


export const getListOnboardingCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listOnboardingCompanies>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListOnboardingCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOnboardingCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListOnboardingCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOnboardingCompanies>>> = ({ signal }) => listOnboardingCompanies(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOnboardingCompanies>>, TError, TData>
}

export type ListOnboardingCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listOnboardingCompanies>>>
export type ListOnboardingCompaniesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List onboarding companies
 */

export function useListOnboardingCompanies<TData = Awaited<ReturnType<typeof listOnboardingCompanies>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListOnboardingCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOnboardingCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOnboardingCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get onboarding company step payload
 */
export const getOnboardingCompany = (
    params?: MaybeRefOrGetter<GetOnboardingCompanyParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingCompanyStep | OnboardingRedirectResult>(
      {url: `/onboarding/company`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingCompanyQueryKey = (params?: MaybeRefOrGetter<GetOnboardingCompanyParams>,) => {
    return [
    'onboarding','company', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingCompany>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingCompanyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingCompanyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingCompany>>> = ({ signal }) => getOnboardingCompany(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingCompany>>, TError, TData>
}

export type GetOnboardingCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingCompany>>>
export type GetOnboardingCompanyQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding company step payload
 */

export function useGetOnboardingCompany<TData = Awaited<ReturnType<typeof getOnboardingCompany>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingCompanyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding company step
 */
export const updateOnboardingCompany = (
    onboardingCompanyStepInput: MaybeRefOrGetter<OnboardingCompanyStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingCompanyParams>,
 signal?: AbortSignal
) => {
      onboardingCompanyStepInput = toValue(onboardingCompanyStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/company`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingCompanyStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingCompanyMutationKey = () => ['updateOnboardingCompany'] as const;

export const getUpdateOnboardingCompanyMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingCompany>>, TError,UpdateOnboardingCompanyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingCompany>>, TError,UpdateOnboardingCompanyMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingCompanyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingCompany>>, UpdateOnboardingCompanyMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingCompany(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingCompany>>>
    export type UpdateOnboardingCompanyMutationBody = OnboardingCompanyStepInput
    export type UpdateOnboardingCompanyMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type UpdateOnboardingCompanyMutationVariables = {data: OnboardingCompanyStepInput;params?: UpdateOnboardingCompanyParams}

    /**
 * @summary Update onboarding company step
 */
export const useUpdateOnboardingCompany = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingCompany>>, TError,UpdateOnboardingCompanyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingCompany>>,
        TError,
        UpdateOnboardingCompanyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingCompanyMutationOptions(options), queryClient);
    }
    /**
 * @summary Skip onboarding company step
 */
export const skipOnboardingCompany = (
    onboardingCompanyStepInput?: MaybeRefOrGetter<OnboardingCompanyStepInput>,
    params?: MaybeRefOrGetter<SkipOnboardingCompanyParams>,
 signal?: AbortSignal
) => {
      onboardingCompanyStepInput = toValue(onboardingCompanyStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/company/skip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingCompanyStepInput,
        params, signal
    },
      );
    }




export const getSkipOnboardingCompanyMutationKey = () => ['skipOnboardingCompany'] as const;

export const getSkipOnboardingCompanyMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingCompany>>, TError,SkipOnboardingCompanyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingCompany>>, TError,SkipOnboardingCompanyMutationVariables, TContext> => {

const mutationKey = getSkipOnboardingCompanyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipOnboardingCompany>>, SkipOnboardingCompanyMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  skipOnboardingCompany(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipOnboardingCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof skipOnboardingCompany>>>
    export type SkipOnboardingCompanyMutationBody = OnboardingCompanyStepInput | undefined
    export type SkipOnboardingCompanyMutationError = ErrorType<SchemaValidationErrorResponse>
    export type SkipOnboardingCompanyMutationVariables = {data?: OnboardingCompanyStepInput;params?: SkipOnboardingCompanyParams}

    /**
 * @summary Skip onboarding company step
 */
export const useSkipOnboardingCompany = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingCompany>>, TError,SkipOnboardingCompanyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof skipOnboardingCompany>>,
        TError,
        SkipOnboardingCompanyMutationVariables,
        TContext
      > => {
      return useMutation(getSkipOnboardingCompanyMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding country step payload
 */
export const getOnboardingCountry = (
    params?: MaybeRefOrGetter<GetOnboardingCountryParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingCountryStep | OnboardingRedirectResult>(
      {url: `/onboarding/country`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingCountryQueryKey = (params?: MaybeRefOrGetter<GetOnboardingCountryParams>,) => {
    return [
    'onboarding','country', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingCountryQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingCountry>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingCountryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingCountry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingCountryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingCountry>>> = ({ signal }) => getOnboardingCountry(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingCountry>>, TError, TData>
}

export type GetOnboardingCountryQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingCountry>>>
export type GetOnboardingCountryQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding country step payload
 */

export function useGetOnboardingCountry<TData = Awaited<ReturnType<typeof getOnboardingCountry>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingCountryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingCountry>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingCountryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding country step
 */
export const updateOnboardingCountry = (
    onboardingCountryStepInput: MaybeRefOrGetter<OnboardingCountryStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingCountryParams>,
 signal?: AbortSignal
) => {
      onboardingCountryStepInput = toValue(onboardingCountryStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/country`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingCountryStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingCountryMutationKey = () => ['updateOnboardingCountry'] as const;

export const getUpdateOnboardingCountryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingCountry>>, TError,UpdateOnboardingCountryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingCountry>>, TError,UpdateOnboardingCountryMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingCountryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingCountry>>, UpdateOnboardingCountryMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingCountry(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingCountryMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingCountry>>>
    export type UpdateOnboardingCountryMutationBody = OnboardingCountryStepInput
    export type UpdateOnboardingCountryMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingCountryMutationVariables = {data: OnboardingCountryStepInput;params?: UpdateOnboardingCountryParams}

    /**
 * @summary Update onboarding country step
 */
export const useUpdateOnboardingCountry = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingCountry>>, TError,UpdateOnboardingCountryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingCountry>>,
        TError,
        UpdateOnboardingCountryMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingCountryMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding grade step payload
 */
export const getOnboardingGrade = (
    params?: MaybeRefOrGetter<GetOnboardingGradeParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingGradeStep | OnboardingRedirectResult>(
      {url: `/onboarding/grade`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingGradeQueryKey = (params?: MaybeRefOrGetter<GetOnboardingGradeParams>,) => {
    return [
    'onboarding','grade', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingGradeQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingGrade>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingGradeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingGrade>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingGradeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingGrade>>> = ({ signal }) => getOnboardingGrade(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingGrade>>, TError, TData>
}

export type GetOnboardingGradeQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingGrade>>>
export type GetOnboardingGradeQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding grade step payload
 */

export function useGetOnboardingGrade<TData = Awaited<ReturnType<typeof getOnboardingGrade>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingGradeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingGrade>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingGradeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding grade step
 */
export const updateOnboardingGrade = (
    onboardingGradeStepInput: MaybeRefOrGetter<OnboardingGradeStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingGradeParams>,
 signal?: AbortSignal
) => {
      onboardingGradeStepInput = toValue(onboardingGradeStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/grade`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingGradeStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingGradeMutationKey = () => ['updateOnboardingGrade'] as const;

export const getUpdateOnboardingGradeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingGrade>>, TError,UpdateOnboardingGradeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingGrade>>, TError,UpdateOnboardingGradeMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingGradeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingGrade>>, UpdateOnboardingGradeMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingGrade(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingGradeMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingGrade>>>
    export type UpdateOnboardingGradeMutationBody = OnboardingGradeStepInput
    export type UpdateOnboardingGradeMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingGradeMutationVariables = {data: OnboardingGradeStepInput;params?: UpdateOnboardingGradeParams}

    /**
 * @summary Update onboarding grade step
 */
export const useUpdateOnboardingGrade = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingGrade>>, TError,UpdateOnboardingGradeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingGrade>>,
        TError,
        UpdateOnboardingGradeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingGradeMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding group step payload
 */
export const getOnboardingGroup = (
    params?: MaybeRefOrGetter<GetOnboardingGroupParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingGroupStep | OnboardingRedirectResult>(
      {url: `/onboarding/group`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingGroupQueryKey = (params?: MaybeRefOrGetter<GetOnboardingGroupParams>,) => {
    return [
    'onboarding','group', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingGroupQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingGroup>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingGroupParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingGroup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingGroupQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingGroup>>> = ({ signal }) => getOnboardingGroup(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingGroup>>, TError, TData>
}

export type GetOnboardingGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingGroup>>>
export type GetOnboardingGroupQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding group step payload
 */

export function useGetOnboardingGroup<TData = Awaited<ReturnType<typeof getOnboardingGroup>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingGroupParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingGroup>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingGroupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding group step
 */
export const updateOnboardingGroup = (
    onboardingGroupStepInput?: MaybeRefOrGetter<OnboardingGroupStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingGroupParams>,
 signal?: AbortSignal
) => {
      onboardingGroupStepInput = toValue(onboardingGroupStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingGroupStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingGroupMutationKey = () => ['updateOnboardingGroup'] as const;

export const getUpdateOnboardingGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingGroup>>, TError,UpdateOnboardingGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingGroup>>, TError,UpdateOnboardingGroupMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingGroup>>, UpdateOnboardingGroupMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingGroup(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingGroup>>>
    export type UpdateOnboardingGroupMutationBody = OnboardingGroupStepInput | undefined
    export type UpdateOnboardingGroupMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingGroupMutationVariables = {data?: OnboardingGroupStepInput;params?: UpdateOnboardingGroupParams}

    /**
 * @summary Update onboarding group step
 */
export const useUpdateOnboardingGroup = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingGroup>>, TError,UpdateOnboardingGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingGroup>>,
        TError,
        UpdateOnboardingGroupMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Skip onboarding group step
 */
export const skipOnboardingGroup = (
    params?: MaybeRefOrGetter<SkipOnboardingGroupParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/group/skip`, method: 'PUT',
        params, signal
    },
      );
    }




export const getSkipOnboardingGroupMutationKey = () => ['skipOnboardingGroup'] as const;

export const getSkipOnboardingGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingGroup>>, TError,SkipOnboardingGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingGroup>>, TError,SkipOnboardingGroupMutationVariables, TContext> => {

const mutationKey = getSkipOnboardingGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipOnboardingGroup>>, SkipOnboardingGroupMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  skipOnboardingGroup(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipOnboardingGroupMutationResult = NonNullable<Awaited<ReturnType<typeof skipOnboardingGroup>>>

    export type SkipOnboardingGroupMutationError = ErrorType<SchemaValidationErrorResponse>
    export type SkipOnboardingGroupMutationVariables = {params?: SkipOnboardingGroupParams}

    /**
 * @summary Skip onboarding group step
 */
export const useSkipOnboardingGroup = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingGroup>>, TError,SkipOnboardingGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof skipOnboardingGroup>>,
        TError,
        SkipOnboardingGroupMutationVariables,
        TContext
      > => {
      return useMutation(getSkipOnboardingGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding info-from step payload
 */
export const getOnboardingInfoFrom = (
    params?: MaybeRefOrGetter<GetOnboardingInfoFromParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingInfoFromStep | OnboardingCompletionResult>(
      {url: `/onboarding/info_from`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingInfoFromQueryKey = (params?: MaybeRefOrGetter<GetOnboardingInfoFromParams>,) => {
    return [
    'onboarding','info_from', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingInfoFromQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingInfoFrom>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingInfoFromParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingInfoFrom>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingInfoFromQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingInfoFrom>>> = ({ signal }) => getOnboardingInfoFrom(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingInfoFrom>>, TError, TData>
}

export type GetOnboardingInfoFromQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingInfoFrom>>>
export type GetOnboardingInfoFromQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding info-from step payload
 */

export function useGetOnboardingInfoFrom<TData = Awaited<ReturnType<typeof getOnboardingInfoFrom>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingInfoFromParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingInfoFrom>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingInfoFromQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding info-from step
 */
export const updateOnboardingInfoFrom = (
    onboardingInfoFromStepInput: MaybeRefOrGetter<OnboardingInfoFromStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingInfoFromParams>,
 signal?: AbortSignal
) => {
      onboardingInfoFromStepInput = toValue(onboardingInfoFromStepInput);
params = toValue(params);

      return axiosClient<OnboardingCompletionResult>(
      {url: `/onboarding/info_from`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingInfoFromStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingInfoFromMutationKey = () => ['updateOnboardingInfoFrom'] as const;

export const getUpdateOnboardingInfoFromMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingInfoFrom>>, TError,UpdateOnboardingInfoFromMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingInfoFrom>>, TError,UpdateOnboardingInfoFromMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingInfoFromMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingInfoFrom>>, UpdateOnboardingInfoFromMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingInfoFrom(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingInfoFromMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingInfoFrom>>>
    export type UpdateOnboardingInfoFromMutationBody = OnboardingInfoFromStepInput
    export type UpdateOnboardingInfoFromMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingInfoFromMutationVariables = {data: OnboardingInfoFromStepInput;params?: UpdateOnboardingInfoFromParams}

    /**
 * @summary Update onboarding info-from step
 */
export const useUpdateOnboardingInfoFrom = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingInfoFrom>>, TError,UpdateOnboardingInfoFromMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingInfoFrom>>,
        TError,
        UpdateOnboardingInfoFromMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingInfoFromMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding international step payload
 */
export const getOnboardingInternational = (
    params?: MaybeRefOrGetter<GetOnboardingInternationalParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingInternationalStep>(
      {url: `/onboarding/international`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingInternationalQueryKey = (params?: MaybeRefOrGetter<GetOnboardingInternationalParams>,) => {
    return [
    'onboarding','international', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingInternationalQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingInternational>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingInternationalParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingInternational>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingInternationalQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingInternational>>> = ({ signal }) => getOnboardingInternational(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingInternational>>, TError, TData>
}

export type GetOnboardingInternationalQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingInternational>>>
export type GetOnboardingInternationalQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding international step payload
 */

export function useGetOnboardingInternational<TData = Awaited<ReturnType<typeof getOnboardingInternational>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingInternationalParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingInternational>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingInternationalQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding international step
 */
export const updateOnboardingInternational = (
    onboardingInternationalStepInput: MaybeRefOrGetter<OnboardingInternationalStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingInternationalParams>,
 signal?: AbortSignal
) => {
      onboardingInternationalStepInput = toValue(onboardingInternationalStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/international`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingInternationalStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingInternationalMutationKey = () => ['updateOnboardingInternational'] as const;

export const getUpdateOnboardingInternationalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingInternational>>, TError,UpdateOnboardingInternationalMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingInternational>>, TError,UpdateOnboardingInternationalMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingInternationalMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingInternational>>, UpdateOnboardingInternationalMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingInternational(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingInternationalMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingInternational>>>
    export type UpdateOnboardingInternationalMutationBody = OnboardingInternationalStepInput
    export type UpdateOnboardingInternationalMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type UpdateOnboardingInternationalMutationVariables = {data: OnboardingInternationalStepInput;params?: UpdateOnboardingInternationalParams}

    /**
 * @summary Update onboarding international step
 */
export const useUpdateOnboardingInternational = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingInternational>>, TError,UpdateOnboardingInternationalMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingInternational>>,
        TError,
        UpdateOnboardingInternationalMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingInternationalMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding job step payload
 */
export const getOnboardingJob = (
    params?: MaybeRefOrGetter<GetOnboardingJobParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingJobStep>(
      {url: `/onboarding/job`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingJobQueryKey = (params?: MaybeRefOrGetter<GetOnboardingJobParams>,) => {
    return [
    'onboarding','job', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingJobQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingJob>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingJob>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingJobQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingJob>>> = ({ signal }) => getOnboardingJob(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingJob>>, TError, TData>
}

export type GetOnboardingJobQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingJob>>>
export type GetOnboardingJobQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding job step payload
 */

export function useGetOnboardingJob<TData = Awaited<ReturnType<typeof getOnboardingJob>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingJob>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingJobQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding job step
 */
export const updateOnboardingJob = (
    onboardingJobStepInput: MaybeRefOrGetter<OnboardingJobStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingJobParams>,
 signal?: AbortSignal
) => {
      onboardingJobStepInput = toValue(onboardingJobStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/job`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingJobStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingJobMutationKey = () => ['updateOnboardingJob'] as const;

export const getUpdateOnboardingJobMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingJob>>, TError,UpdateOnboardingJobMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingJob>>, TError,UpdateOnboardingJobMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingJobMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingJob>>, UpdateOnboardingJobMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingJob(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingJob>>>
    export type UpdateOnboardingJobMutationBody = OnboardingJobStepInput
    export type UpdateOnboardingJobMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type UpdateOnboardingJobMutationVariables = {data: OnboardingJobStepInput;params?: UpdateOnboardingJobParams}

    /**
 * @summary Update onboarding job step
 */
export const useUpdateOnboardingJob = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingJob>>, TError,UpdateOnboardingJobMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingJob>>,
        TError,
        UpdateOnboardingJobMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingJobMutationOptions(options), queryClient);
    }
    /**
 * @summary Skip onboarding job step
 */
export const skipOnboardingJob = (
    params?: MaybeRefOrGetter<SkipOnboardingJobParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/job/skip`, method: 'PUT',
        params, signal
    },
      );
    }




export const getSkipOnboardingJobMutationKey = () => ['skipOnboardingJob'] as const;

export const getSkipOnboardingJobMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingJob>>, TError,SkipOnboardingJobMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingJob>>, TError,SkipOnboardingJobMutationVariables, TContext> => {

const mutationKey = getSkipOnboardingJobMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipOnboardingJob>>, SkipOnboardingJobMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  skipOnboardingJob(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipOnboardingJobMutationResult = NonNullable<Awaited<ReturnType<typeof skipOnboardingJob>>>

    export type SkipOnboardingJobMutationError = ErrorType<SchemaValidationErrorResponse>
    export type SkipOnboardingJobMutationVariables = {params?: SkipOnboardingJobParams}

    /**
 * @summary Skip onboarding job step
 */
export const useSkipOnboardingJob = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingJob>>, TError,SkipOnboardingJobMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof skipOnboardingJob>>,
        TError,
        SkipOnboardingJobMutationVariables,
        TContext
      > => {
      return useMutation(getSkipOnboardingJobMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding name step payload
 */
export const getOnboardingName = (
    params?: MaybeRefOrGetter<GetOnboardingNameParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingNameStep>(
      {url: `/onboarding/name`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingNameQueryKey = (params?: MaybeRefOrGetter<GetOnboardingNameParams>,) => {
    return [
    'onboarding','name', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingNameQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingName>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<GetOnboardingNameParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingName>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingName>>> = ({ signal }) => getOnboardingName(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingName>>, TError, TData>
}

export type GetOnboardingNameQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingName>>>
export type GetOnboardingNameQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get onboarding name step payload
 */

export function useGetOnboardingName<TData = Awaited<ReturnType<typeof getOnboardingName>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<GetOnboardingNameParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingName>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding name step
 */
export const updateOnboardingName = (
    onboardingNameStepInput: MaybeRefOrGetter<OnboardingNameStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingNameParams>,
 signal?: AbortSignal
) => {
      onboardingNameStepInput = toValue(onboardingNameStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingNameStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingNameMutationKey = () => ['updateOnboardingName'] as const;

export const getUpdateOnboardingNameMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingName>>, TError,UpdateOnboardingNameMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingName>>, TError,UpdateOnboardingNameMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingNameMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingName>>, UpdateOnboardingNameMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingName(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingNameMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingName>>>
    export type UpdateOnboardingNameMutationBody = OnboardingNameStepInput
    export type UpdateOnboardingNameMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type UpdateOnboardingNameMutationVariables = {data: OnboardingNameStepInput;params?: UpdateOnboardingNameParams}

    /**
 * @summary Update onboarding name step
 */
export const useUpdateOnboardingName = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingName>>, TError,UpdateOnboardingNameMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingName>>,
        TError,
        UpdateOnboardingNameMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingNameMutationOptions(options), queryClient);
    }
    /**
 * @summary Get re-onboarding state
 */
export const getOnboardingReOnboarding = (
    params?: MaybeRefOrGetter<GetOnboardingReOnboardingParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingReOnboardingState>(
      {url: `/onboarding/re_onboarding`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingReOnboardingQueryKey = (params?: MaybeRefOrGetter<GetOnboardingReOnboardingParams>,) => {
    return [
    'onboarding','re_onboarding', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingReOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingReOnboarding>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<GetOnboardingReOnboardingParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingReOnboarding>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingReOnboardingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingReOnboarding>>> = ({ signal }) => getOnboardingReOnboarding(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingReOnboarding>>, TError, TData>
}

export type GetOnboardingReOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingReOnboarding>>>
export type GetOnboardingReOnboardingQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get re-onboarding state
 */

export function useGetOnboardingReOnboarding<TData = Awaited<ReturnType<typeof getOnboardingReOnboarding>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<GetOnboardingReOnboardingParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingReOnboarding>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingReOnboardingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get onboarding region step payload
 */
export const getOnboardingRegion = (
    params?: MaybeRefOrGetter<GetOnboardingRegionParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingRegionStep | OnboardingRedirectResult>(
      {url: `/onboarding/region`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingRegionQueryKey = (params?: MaybeRefOrGetter<GetOnboardingRegionParams>,) => {
    return [
    'onboarding','region', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingRegionQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingRegion>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingRegionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingRegion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingRegionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingRegion>>> = ({ signal }) => getOnboardingRegion(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingRegion>>, TError, TData>
}

export type GetOnboardingRegionQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingRegion>>>
export type GetOnboardingRegionQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding region step payload
 */

export function useGetOnboardingRegion<TData = Awaited<ReturnType<typeof getOnboardingRegion>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingRegionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingRegion>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingRegionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding region step
 */
export const updateOnboardingRegion = (
    onboardingRegionStepInput: MaybeRefOrGetter<OnboardingRegionStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingRegionParams>,
 signal?: AbortSignal
) => {
      onboardingRegionStepInput = toValue(onboardingRegionStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/region`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingRegionStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingRegionMutationKey = () => ['updateOnboardingRegion'] as const;

export const getUpdateOnboardingRegionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingRegion>>, TError,UpdateOnboardingRegionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingRegion>>, TError,UpdateOnboardingRegionMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingRegionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingRegion>>, UpdateOnboardingRegionMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingRegion(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingRegionMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingRegion>>>
    export type UpdateOnboardingRegionMutationBody = OnboardingRegionStepInput
    export type UpdateOnboardingRegionMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingRegionMutationVariables = {data: OnboardingRegionStepInput;params?: UpdateOnboardingRegionParams}

    /**
 * @summary Update onboarding region step
 */
export const useUpdateOnboardingRegion = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingRegion>>, TError,UpdateOnboardingRegionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingRegion>>,
        TError,
        UpdateOnboardingRegionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingRegionMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding entry state
 */
export const getOnboardingState = (
    params?: MaybeRefOrGetter<GetOnboardingStateParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingState>(
      {url: `/onboarding/state`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingStateQueryKey = (params?: MaybeRefOrGetter<GetOnboardingStateParams>,) => {
    return [
    'onboarding','state', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingStateQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingState>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<GetOnboardingStateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingStateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingState>>> = ({ signal }) => getOnboardingState(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingState>>, TError, TData>
}

export type GetOnboardingStateQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingState>>>
export type GetOnboardingStateQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get onboarding entry state
 */

export function useGetOnboardingState<TData = Awaited<ReturnType<typeof getOnboardingState>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<GetOnboardingStateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingStateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get onboarding subject step payload
 */
export const getOnboardingSubject = (
    params?: MaybeRefOrGetter<GetOnboardingSubjectParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingSubjectStep | OnboardingRedirectResult>(
      {url: `/onboarding/subject`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingSubjectQueryKey = (params?: MaybeRefOrGetter<GetOnboardingSubjectParams>,) => {
    return [
    'onboarding','subject', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingSubjectQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingSubject>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingSubjectParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingSubject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingSubjectQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingSubject>>> = ({ signal }) => getOnboardingSubject(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingSubject>>, TError, TData>
}

export type GetOnboardingSubjectQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingSubject>>>
export type GetOnboardingSubjectQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding subject step payload
 */

export function useGetOnboardingSubject<TData = Awaited<ReturnType<typeof getOnboardingSubject>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingSubjectParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingSubject>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingSubjectQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding subject step
 */
export const updateOnboardingSubject = (
    onboardingSubjectStepInput: MaybeRefOrGetter<OnboardingSubjectStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingSubjectParams>,
 signal?: AbortSignal
) => {
      onboardingSubjectStepInput = toValue(onboardingSubjectStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/subject`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingSubjectStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingSubjectMutationKey = () => ['updateOnboardingSubject'] as const;

export const getUpdateOnboardingSubjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingSubject>>, TError,UpdateOnboardingSubjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingSubject>>, TError,UpdateOnboardingSubjectMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingSubjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingSubject>>, UpdateOnboardingSubjectMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingSubject(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingSubjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingSubject>>>
    export type UpdateOnboardingSubjectMutationBody = OnboardingSubjectStepInput
    export type UpdateOnboardingSubjectMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingSubjectMutationVariables = {data: OnboardingSubjectStepInput;params?: UpdateOnboardingSubjectParams}

    /**
 * @summary Update onboarding subject step
 */
export const useUpdateOnboardingSubject = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingSubject>>, TError,UpdateOnboardingSubjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingSubject>>,
        TError,
        UpdateOnboardingSubjectMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingSubjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Get onboarding tool step payload
 */
export const getOnboardingTool = (
    params?: MaybeRefOrGetter<GetOnboardingToolParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<OnboardingToolStep | OnboardingRedirectResult>(
      {url: `/onboarding/tool`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetOnboardingToolQueryKey = (params?: MaybeRefOrGetter<GetOnboardingToolParams>,) => {
    return [
    'onboarding','tool', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOnboardingToolQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingTool>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GetOnboardingToolParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingTool>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingToolQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingTool>>> = ({ signal }) => getOnboardingTool(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingTool>>, TError, TData>
}

export type GetOnboardingToolQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingTool>>>
export type GetOnboardingToolQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Get onboarding tool step payload
 */

export function useGetOnboardingTool<TData = Awaited<ReturnType<typeof getOnboardingTool>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GetOnboardingToolParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboardingTool>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingToolQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update onboarding tool step
 */
export const updateOnboardingTool = (
    onboardingToolStepInput: MaybeRefOrGetter<OnboardingToolStepInput>,
    params?: MaybeRefOrGetter<UpdateOnboardingToolParams>,
 signal?: AbortSignal
) => {
      onboardingToolStepInput = toValue(onboardingToolStepInput);
params = toValue(params);

      return axiosClient<OnboardingNextPathResult>(
      {url: `/onboarding/tool`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingToolStepInput,
        params, signal
    },
      );
    }




export const getUpdateOnboardingToolMutationKey = () => ['updateOnboardingTool'] as const;

export const getUpdateOnboardingToolMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingTool>>, TError,UpdateOnboardingToolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingTool>>, TError,UpdateOnboardingToolMutationVariables, TContext> => {

const mutationKey = getUpdateOnboardingToolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOnboardingTool>>, UpdateOnboardingToolMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateOnboardingTool(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOnboardingToolMutationResult = NonNullable<Awaited<ReturnType<typeof updateOnboardingTool>>>
    export type UpdateOnboardingToolMutationBody = OnboardingToolStepInput
    export type UpdateOnboardingToolMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateOnboardingToolMutationVariables = {data: OnboardingToolStepInput;params?: UpdateOnboardingToolParams}

    /**
 * @summary Update onboarding tool step
 */
export const useUpdateOnboardingTool = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOnboardingTool>>, TError,UpdateOnboardingToolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOnboardingTool>>,
        TError,
        UpdateOnboardingToolMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOnboardingToolMutationOptions(options), queryClient);
    }
